import "@tm/utils"
import { LocalizationConfig } from "../models"
import { getSupportedLocal } from "./helper"

export default function formatNumber(
    config: LocalizationConfig,
    value: number,
    minmumDecimal: number = 2,
    maxiumDecimal: number | undefined = undefined
): string {
    if (value == null) {
        value = 0
    } else {
        value = parseFloat(value.toFixed(maxiumDecimal ?? minmumDecimal))
    }

    const languageAsLocal = getSupportedLocal(config.language)
    return Intl.NumberFormat(languageAsLocal, { minimumFractionDigits: minmumDecimal, maximumFractionDigits: maxiumDecimal }).format(value)
}
